export default __webpack_public_path__ + "static/media/nvidia--white.8295305b.svg";